module.exports = __webpack_public_path__ + "img/appImage-signup-forms--2.74892a31.svg";